import { Sprint } from '@amzn/awscat-portfolio-assessment-types';
import { Button, CollectionPreferencesProps, SpaceBetween, Table, TableProps } from '@amzn/awsui-components-react';
import { useEffect, useState } from 'react';

import { constants } from '../../common/Localization';
import { getResourceCostColumns } from './migration-helper';
import MigrationTablePreferences from './MigrationTablePreferences';

interface Props {
    currency: string;
    sprints: Sprint[];
}

function MigrationSummaryCostResourceTable({ currency, sprints }: Props) {

    const [ columnDefinitions, setColumnDefinitions ] = useState<TableProps.ColumnDefinition<Sprint>[]>([]);
    const [ visibleColumns, setVisibleColumn ] = useState<string[]>([]);
    const [ visibleColumnOptions, setVisibleColumnOptions ] = useState<CollectionPreferencesProps.VisibleContentPreference>();
    const [ preferencesVisible, setPreferencesVisible ] = useState(false);

    useEffect(() => {
        setColumnDefinitions(getResourceCostColumns(currency));
    }, [sprints, currency]);

    useEffect(() => {
        if (columnDefinitions.length === 0) {
            return;
        }

        const getVisibleColumnOptions = (): CollectionPreferencesProps.VisibleContentPreference => {
            const options = columnDefinitions.map(column => {
                return {
                    id: column.id ?? '',
                    label: column.header?.toString() ?? ''
                };
            });
            return {
                title: '',
                options: [{
                    label: constants.SHOW_HIDE_COLUMN,
                    options
                }]
            };
        };

        const defaultVisibleColumns = columnDefinitions.map(column => column.id ?? '');
        setVisibleColumn(defaultVisibleColumns);
        setVisibleColumnOptions(getVisibleColumnOptions());
    }, [columnDefinitions]);
    
    const preferencesComponent = (
        <MigrationTablePreferences
            visibleColumns={visibleColumns}
            setVisibleColumns={setVisibleColumn}
            visibleContentOptions={visibleColumnOptions}
            visible={preferencesVisible}
            setVisible={setPreferencesVisible}
            disabled={!visibleColumnOptions}
        />
    );

    const showPreferencesButton = (
        <Button variant='icon' iconName='settings' onClick={() => setPreferencesVisible(true)}/>
    );

    return (
        <SpaceBetween size='s'>
            <Table 
                items={sprints}
                columnDefinitions={columnDefinitions}
                visibleColumns={visibleColumns}
                preferences={showPreferencesButton}
            />
            {preferencesComponent}
        </SpaceBetween>
    );
}

export default MigrationSummaryCostResourceTable;
